import React, { ReactElement } from 'react';

import { getResponsiveClassNames } from '../../shared/helpers/getResponsiveClassNames';
import { IParentProps } from '../../shared/types/IParentProps';
import { IResponsive } from '../../shared/types/IResponsive';
import { IResponsiveClassNames } from '../../shared/types/IResponsiveClassNames';
import { SCREEN_SIZES } from '../../shared/types/SCREEN_SIZES';

import { PRODUCT_CARD_SIZES } from './PRODUCT_CARD_SIZES';
import { useResponsiveProductCardSizes } from './useResponsiveProductCardSizes';

export type IProductCardTitleProps = IParentProps;

const responsiveTextClassNames: IResponsiveClassNames<PRODUCT_CARD_SIZES> = {
    [SCREEN_SIZES.SMALL]: {
        [PRODUCT_CARD_SIZES.DEFAULT]: 'text-base',
        [PRODUCT_CARD_SIZES.EXTRA_SMALL]: 'text-sm',
    },
    [SCREEN_SIZES.MEDIUM]: {
        [PRODUCT_CARD_SIZES.DEFAULT]: 'md:text-base',
        [PRODUCT_CARD_SIZES.EXTRA_SMALL]: 'md:text-sm',
    },
    [SCREEN_SIZES.LARGE]: {
        [PRODUCT_CARD_SIZES.DEFAULT]: 'lg:text-base',
        [PRODUCT_CARD_SIZES.EXTRA_SMALL]: 'lg:text-sm',
    },
};

export function OzProductCardTitle (props: IProductCardTitleProps): ReactElement {
    const { children }: IProductCardTitleProps = props;
    const size: IResponsive<PRODUCT_CARD_SIZES> = useResponsiveProductCardSizes();
    const textClassNames: string = getResponsiveClassNames(size, responsiveTextClassNames);

    return <div className={`${textClassNames} font-bold mb-1/2`}>{children}</div>;
}
